// import React, { useState, useEffect } from 'react';
// import { axiosV2 } from '../../../utils/BasicAuthAPI';
// import moment from "moment";
// import "../audit.css";
// import { Modal, Form, Input, Select, DatePicker, Button, message, Typography, Col, Row } from 'antd';
// import { useParams, Link } from "react-router-dom";

// const CreateAndEditAudit = (props) => {

//     const [state, setState] = useState({
//         visible: false,
//         disabledBtn: false,
//         AuditLines: { loaded: false, data: [] },
//         AuditType: { loaded: false, data: [] },
//         AuditSubType: { loaded: false, data: [] },
//         AuditUsers: { loaded: false, data: [] }
//     })
//     const [form] = Form.useForm();

//     const onFinish = (values) => {
//         setState({ ...state, disabledBtn: true });

//         const reqDat = { ...values, AuditDt: values["AuditDt"] ? values["AuditDt"].format("YYYY/MM/DD") : null, "TGT": null, };

//         if (props.isEdit) {
//             reqDat["_id"] = props.defaultData.id
//             axiosV2.patch('audit/session', reqDat).then(({ data }) => {
//                 const msg = data["Message"] ? data["Message"] : "Successfully edit!";
//                 message.success(msg, 4)
//                 // setVisible(false);
//                 // props.modelCloseHandler(reqDat);
//                 setState({ ...state, disabledBtn: false });

//             }).catch(function (error) {
//                 message.error("ERROR: Unable to edit!!", 2);
//                 console.log("Error****: fetch calendar", error);
//                 setState({ ...state, disabledBtn: false });
//             });
//         } else {
//             delete reqDat["Search"];
//             delete reqDat["Status"];
//             axiosV2.post('audit/session', reqDat).then(({ data }) => {
//                 const msg = data["Message"] ? data["Message"] : "Successfully Added!";
//                 message.success(msg, 4)
//                 setState({ ...state, disabledBtn: false });
//                 form.resetFields();

//             }).catch(function (error) {
//                 message.error("ERROR: Unable to add!!", 2);
//                 console.log("Error****: fetch calendar", error);
//                 setState({ ...state, disabledBtn: false });
//             });
//         }

//     }

//     const fetchLine = () => {
//         axiosV2.get('mdict', {
//             params: {
//                 typ: "Line",
//                 subTyp: "Idame"
//             }
//         }).then(({ data }) => {
//             const keys = Object.keys(data["Data"]);
//             const resData = keys.map((key) => { return { id: key, name: data["Data"][key] } });

//             setState({ ...state, AuditLines: { loaded: true, data: resData } });
//         }).catch(function (error) {
//             console.log("Error****: fetch Line", error);
//         });
//     }
//     const fetchType = () => {
//         axiosV2.get('mdict', {
//             params: {
//                 typ: "AuditTypes",
//                 subTyp: "Idame"
//             }
//         }).then(({ data }) => {
//             const resData = data["Data"].map((obj) => {
//                 const k = Object.keys(obj)[0];
//                 return { id: k, name: obj[k] }
//             });
//             setState({ ...state, AuditType: { loaded: true, data: resData } });
//         }).catch(function (error) {
//             console.log("Error****: fetch type", error);
//         });
//     }
//     const fetchSubType = () => {
//         const typ = form.getFieldValue("TYP");
//         form.setFieldsValue({ ...form.getFieldsValue(["TYP", "LID", "Status", "Auditor", "Auditee", "Team", "AuditDt", "Search"]), "SUBTYP": null })
//         axiosV2.get('mdict', {
//             params: {
//                 typ: "AuditSubTypes",
//                 subTyp: "TreeData",
//                 queryKey: typ
//             }
//         }).then(({ data }) => {

//             const subTyp = data["Data"][typ] ? data["Data"][typ] : [];
//             console.log(subTyp);
//             setState({ ...state, AuditSubType: { loaded: true, data: subTyp } });
//         }).catch(function (error) {
//             console.log("Error****: fetch subtype", error);
//         });
//     }
//     const fetchUser = () => {
//         axiosV2.get('mdict', {
//             params: {
//                 typ: "User",
//                 subTyp: "Idame"
//             }
//         }).then(({ data }) => {
//             const keys = Object.keys(data["Data"]);
//             const resData = keys.map((key) => { return { id: key, name: data["Data"][key] } });
//             setState({ ...state, AuditUsers: { loaded: true, data: resData } });
//         }).catch(function (error) {
//             console.log("Error****: fetch user", error);
//         });
//     }

//     useEffect(() => {
//         console.log("AuditLines", state.AuditLines.loaded);
//         if (!state.AuditLines.loaded && state.AuditLines.data.length === 0) {
//             fetchLine();
//         }
//     }, [state.AuditLines.loaded])
//     useEffect(() => {
//         console.log("AuditType", state.AuditType.loaded && state.AuditType.data.length === 0);
//         if (!state.AuditType.loaded) {
//             fetchType();
//         }
//     }, [state.AuditType.loaded])
//     useEffect(() => {
//         console.log("AuditUsers", state.AuditUsers.loaded);
//         if (!state.AuditUsers.loaded && state.AuditUsers.data.length === 0) {
//             fetchUser();
//         }
//     }, [state.AuditUsers.loaded])

//     useEffect(() => {
//         if (props.defaultData) {
//             form.setFieldsValue({ ...props.defaultData })
//         }
//     }, [props])

//     return (
//         <div className='AuditSection CreateAudit' style={{ padding: "20px" }}>
//             <div className="ThemeForm">

//                 <Form
//                     form={form}
//                     name="evntForm"
//                     labelCol={{ span: 8 }}
//                     wrapperCol={{ span: 16 }}
//                     layout="horizontal"
//                     colon={false}
//                     onFinish={onFinish}
//                     size="large"
//                 >
//                     <Row gutter={24} justify="space-around" align="middle">
//                         <Col span={12}>
//                             <h4 className="title textCenter">{props.isEdit === true ? "Edit" : "Create"} Audit Session</h4>
//                             <Form.Item
//                                 name="LID"
//                                 label="Line"
//                                 rules={[
//                                     {
//                                         required: true,
//                                         message: 'Please select a line',
//                                     },
//                                 ]}
//                             >
//                                 <Select
//                                     showSearch
//                                     placeholder="Select a person"
//                                     optionFilterProp="children"
//                                     filterOption={(input, option) => {
//                                         return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//                                     }
//                                     }
//                                 >
//                                     {
//                                         state.AuditLines.data.map((opt, key) => {
//                                             return <Select.Option key={"lines_" + key} value={opt.id}>{opt.name}</Select.Option>
//                                         })
//                                     }

//                                 </Select>
//                             </Form.Item>
//                             <Form.Item
//                                 name="TYP"
//                                 label="Type"
//                                 rules={[
//                                     {
//                                         required: true,
//                                         message: 'Please select a type',
//                                     },
//                                 ]}
//                             >
//                                 <Select
//                                     showSearch
//                                     placeholder="Select a type"
//                                     optionFilterProp="children"
//                                     onChange={fetchSubType}
//                                     filterOption={(input, option) => {
//                                         return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//                                     }
//                                     }
//                                 >
//                                     {
//                                         state.AuditType.data.map((opt, key) => {
//                                             return <Select.Option key={"type_" + key} value={opt.id}>{opt.name}</Select.Option>
//                                         })
//                                     }

//                                 </Select>
//                             </Form.Item>
//                             <Form.Item
//                                 name="SUBTYP"
//                                 label="Sub-Type"
//                                 rules={[
//                                     {
//                                         required: true,
//                                         message: 'Please select a sub-type',
//                                     },
//                                 ]}
//                             >
//                                 <Select
//                                     showSearch
//                                     placeholder="Select a sub-type"
//                                     optionFilterProp="children"
//                                     filterOption={(input, option) => {
//                                         return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//                                     }
//                                     }
//                                 >
//                                     {
//                                         state.AuditSubType.data.map((opt, key) => {
//                                             return <Select.Option key={"subtype_" + key} value={opt._id}>{opt.SUBTYP}</Select.Option>
//                                         })
//                                     }

//                                 </Select>
//                             </Form.Item>
//                             {props.isEdit === true ?
//                                 <Form.Item
//                                     name="Status"
//                                     label="Status"
//                                     placeholder="Select a Status"
//                                     rules={[{ required: true }]}
//                                 >
//                                     <Select placeholder="Please select a status" optionLabelProp="label">
//                                         <Select.Option key={"status_O"} value="O" label="Open">
//                                             <div style={{ borderLeft: "5px solid", borderColor: "#e74c3c", paddingLeft: "10px" }}>Open</div>
//                                         </Select.Option>
//                                         <Select.Option key={"status_C"} value="C" label="Close">
//                                             <div style={{ borderLeft: "5px solid", borderColor: "#2ecc71", paddingLeft: "10px" }}>Close</div>

//                                         </Select.Option>
//                                         <Select.Option key={"status_H"} value="H" label="Hold">
//                                             <div style={{ borderLeft: "5px solid", borderColor: "#3498db", paddingLeft: "10px" }}>Hold</div>

//                                         </Select.Option>
//                                         <Select.Option key={"status_X"} value="X" label="Cancelled">
//                                             <div style={{ borderLeft: "5px solid", borderColor: "#ecf0f1", paddingLeft: "10px" }}>Cancelled</div>

//                                         </Select.Option>
//                                     </Select>
//                                 </Form.Item> : null
//                             }
//                             <Form.Item
//                                 name="Auditor"
//                                 label="Auditor"
//                                 rules={[
//                                     {
//                                         required: true,
//                                         message: 'Please select a Auditor',
//                                     },
//                                 ]}
//                             >
//                                 <Select
//                                     showSearch
//                                     placeholder="Select a Auditor"
//                                     optionFilterProp="children"
//                                     filterOption={(input, option) => {
//                                         return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//                                     }
//                                     }
//                                 >
//                                     {
//                                         state.AuditUsers.data.map((opt, key) => {
//                                             return <Select.Option key={"auditor_" + key} value={opt.id}>{opt.name}</Select.Option>
//                                         })
//                                     }

//                                 </Select>
//                             </Form.Item>
//                             <Form.Item
//                                 name="Auditee"
//                                 label="Auditee"
//                                 rules={[
//                                     {
//                                         required: true,
//                                         message: 'Please select a Auditee',
//                                     },
//                                 ]}
//                             >
//                                 <Select
//                                     showSearch
//                                     placeholder="Select a Auditee"
//                                     optionFilterProp="children"
//                                     filterOption={(input, option) => {
//                                         return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//                                     }
//                                     }
//                                 >
//                                     {
//                                         state.AuditUsers.data.map((opt, key) => {
//                                             return <Select.Option key={"auditee_" + key} value={opt.id}>{opt.name}</Select.Option>
//                                         })
//                                     }

//                                 </Select>
//                             </Form.Item>
//                             <Form.Item
//                                 name="Team"
//                                 label="Team"
//                                 rules={[
//                                     {
//                                         required: true,
//                                         message: 'Please select a Team',
//                                     },
//                                 ]}
//                             >
//                                 <Select
//                                     showSearch
//                                     placeholder="Select a Team"
//                                     mode="multiple"
//                                     optionFilterProp="children"
//                                     filterOption={(input, option) => {
//                                         return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//                                     }
//                                     }
//                                 >
//                                     {
//                                         state.AuditUsers.data.map((opt, key) => {
//                                             return <Select.Option key={"auditee_" + key} value={opt.id}>{opt.name}</Select.Option>
//                                         })
//                                     }

//                                 </Select>
//                             </Form.Item>

//                             <Form.Item
//                                 name="AuditDt"
//                                 label="Date"
//                                 placeholder="Select a Date"
//                                 rules={[{ required: true }]}
//                             >
//                                 <DatePicker className="gx-mb-3 gx-w-100" placeholder="Select a Date" />
//                             </Form.Item>
//                             <Form.Item className="formBtnGroup" label=" " colon={false}>
//                                 <Button style={{ textAlign: "center" }} type="primary" htmlType="submit" className="login-form-button gx-mt-1 bigBtn"
//                                     disabled={
//                                         state.disabledBtn
//                                     }
//                                 >
//                                     {"Submit"}
//                                 </Button>
//                                 <Link to="/audit-list" className="nextBtn">
//                                     <Button style={{ textAlign: "center" }} type="danger" htmlType="button" className="login-form-button gx-mt-1 bigBtn"
//                                         disabled={
//                                             state.disabledBtn
//                                         }
//                                     >
//                                         {"Back to Audit List"}
//                                     </Button>
//                                 </Link>
//                             </Form.Item>

//                         </Col>
//                     </Row>
//                 </Form>
//             </div>
//         </div>
//     )

// }

// export default CreateAndEditAudit;

import React, { useState, useEffect } from "react";
import { axiosV2 } from "../../../utils/BasicAuthAPI";
import moment from "moment";
import "../audit.css";
import {
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  message,
  Typography,
  Col,
  Row,
} from "antd";
import liracrypt from "../../Liracrypt/liracrypt";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";

const CreateAndEditAudit = (props) => {
  const [state, setState] = useState({
    visible: false,
    disabledBtn: false,
  });
  const [loginError, setLoginError] = useState(false);

  const [AuditLines, setAuditLines] = useState({ loaded: false, data: [] });
  const [AuditType, setAuditType] = useState({ loaded: false, data: [] });
  const [AuditSubType, setAuditSubType] = useState({ loaded: false, data: [] });
  const [AuditUsers, setAuditUsers] = useState({ loaded: false, data: [] });
  const [form] = Form.useForm();

  const onFinish = (values) => {
    setState({ ...state, disabledBtn: true });

    const reqDat = {
      ...values,
      AuditDt: values["audDt"] ? values["audDt"].format("YYYY/MM/DD") : null,
      TGT: null,
    };

    if (props.isEdit) {
      reqDat["_id"] = props.defaultValues.id;
      liracrypt
        .patch("/audit/session", reqDat)
        .then((res, req) => {
          let data = res.data;
          const msg = data["message"] ? data["message"] : "Successfully edit!";
          message.success(msg, 4);
          // setVisible(false);
          // props.modelCloseHandler(reqDat);
          setState({ ...state, disabledBtn: false });
          props.sendBackData(reqDat);
        })
        .catch(function (error) {
          message.error("ERROR: Unable to edit!!", 2);
          console.log("Error****: fetch calendar", error);
          setState({ ...state, disabledBtn: false });
          if (error.response !== undefined) {
            if (error.response.status !== 401) {
              ApiErrorComp(error.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    } else {
      delete reqDat["Search"];
      delete reqDat["status"];
      liracrypt
        .post("/audit/session", reqDat)
        .then((res, req) => {
          let data = res.data;
          const msg = data["message"] ? data["message"] : "Successfully Added!";
          message.success(msg, 4);
          setState({ ...state, disabledBtn: false });
          form.resetFields();
          props.sendBackData(reqDat);
        })
        .catch(function (error) {
          message.error("ERROR: Unable to add!!", 2);
          console.log("Error****: fetch calendar", error);
          setState({ ...state, disabledBtn: false });
          if (error.response !== undefined) {
            if (error.response.status !== 401) {
              // ApiErrorComp(error.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    }
  };

  const fetchSubType = (reset) => {
    const typ = form.getFieldValue("typ");
    form.setFieldsValue({
      ...form.getFieldsValue([
        "typ",
        "lid",
        "status",
        "auditor",
        "auditee",
        "team",
        "audDt",
      ]),
      SUBTYP: null,
    });
    liracrypt
      .get("/mdict", {
        typ: "AuditTypes",
        subTyp: "treeData",
        queryKey: typ,
      })
      .then((res, req) => {
        let data = res.data;
        const subTyp = data["data"][typ] ? data["data"][typ] : [];
        setAuditSubType({ loaded: true, data: subTyp });
      })
      .catch(function (error) {
        console.log("Error****: fetch subtype", error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            // ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  useEffect(() => {
    if (props.defaultValues) {
      form.setFieldsValue({ ...props.defaultValues });
      if (props.defaultValues["typ"]) {
        fetchSubType(true);
      }
    }
    if (props.AuditLines) {
      setAuditLines({ loaded: true, data: props.AuditLines });
    }
    if (props.AuditType) {
      setAuditType({ loaded: true, data: props.AuditType });
    }
    if (props.AuditUsers) {
      setAuditUsers({ loaded: true, data: props.AuditUsers });
    }
    
  }, [props]);

  useEffect(() => {
    if (props.defaultValues && props.defaultValues["subTyp"] && form) {
      const typ = form.getFieldValue("typ");
      form.setFieldsValue({
        ...form.getFieldsValue([
          "typ",
          "lid",
          "status",
          "auditor",
          "auditee",
          "team",
          "audDt",
        ]),
        SUBTYP:
          typ === props.defaultValues["typ"]
            ? props.defaultValues["subTyp"]
            : null,
      });
    }
  }, [AuditSubType]);

  // const modelCloseHandler = () => {
  //     setState({ visible: false, selectedEvent: null });

  // }

  return (
    <>
      <SessionError visible={loginError} />
      <div className="AuditSection CreateAudit" style={{ padding: "20px" }}>
        <div className="ThemeForm">
          <Form
            form={form}
            name="evntForm"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
            colon={false}
            onFinish={onFinish}
            size="large"
          >
            <Row gutter={24} justify="space-around" align="middle">
              <Col span={24}>
                <h4 className="title textCenter">
                  {props.isEdit === true ? "Edit" : "Create"} Audit Session
                </h4>
                <Form.Item
                  name="LID"
                  label="Line"
                  rules={[
                    {
                      required: true,
                      message: "Please select a line",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select a person"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                  >
                    {AuditLines.data.map((opt, key) => {
                      return (
                        <Select.Option key={"lines_" + key} value={opt.id}>
                          {opt.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="TYP"
                  label="Type"
                  rules={[
                    {
                      required: true,
                      message: "Please select a type",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select a type"
                    optionFilterProp="children"
                    onChange={fetchSubType}
                    filterOption={(input, option) => {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                  >
                    {AuditType.data.map((opt, key) => {
                      return (
                        <Select.Option key={"type_" + key} value={opt.id}>
                          {opt.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="SUBTYP"
                  label="Sub-Type"
                  rules={[
                    {
                      required: true,
                      message: "Please select a sub-type",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select a sub-type"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                  >
                    {AuditSubType.data.map((opt, key) => {
                      return (
                        <Select.Option key={"subtype_" + key} value={opt._id}>
                          {opt.SUBTYP}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                {props.isEdit === true ? (
                  <Form.Item
                    name="Status"
                    label="Status"
                    placeholder="Select a Status"
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder="Please select a status"
                      optionLabelProp="label"
                    >
                      <Select.Option key={"status_O"} value="O" label="Open">
                        <div
                          style={{
                            borderLeft: "5px solid",
                            borderColor: "#e74c3c",
                            paddingLeft: "10px",
                          }}
                        >
                          Open
                        </div>
                      </Select.Option>
                      <Select.Option key={"status_C"} value="C" label="Close">
                        <div
                          style={{
                            borderLeft: "5px solid",
                            borderColor: "#2ecc71",
                            paddingLeft: "10px",
                          }}
                        >
                          Close
                        </div>
                      </Select.Option>
                      <Select.Option key={"status_H"} value="H" label="Hold">
                        <div
                          style={{
                            borderLeft: "5px solid",
                            borderColor: "#3498db",
                            paddingLeft: "10px",
                          }}
                        >
                          Hold
                        </div>
                      </Select.Option>
                      <Select.Option
                        key={"status_X"}
                        value="X"
                        label="Cancelled"
                      >
                        <div
                          style={{
                            borderLeft: "5px solid",
                            borderColor: "#ecf0f1",
                            paddingLeft: "10px",
                          }}
                        >
                          Cancelled
                        </div>
                      </Select.Option>
                    </Select>
                  </Form.Item>
                ) : null}
                <Form.Item
                  name="Auditor"
                  label="Auditor"
                  rules={[
                    {
                      required: true,
                      message: "Please select a Auditor",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select a Auditor"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                  >
                    {AuditUsers.data.map((opt, key) => {
                      return (
                        <Select.Option key={"auditor_" + key} value={opt.id}>
                          {opt.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="Auditee"
                  label="Auditee"
                  rules={[
                    {
                      required: true,
                      message: "Please select a Auditee",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select a Auditee"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                  >
                    {AuditUsers.data.map((opt, key) => {
                      return (
                        <Select.Option key={"auditee_" + key} value={opt.id}>
                          {opt.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="Team"
                  label="Team"
                  rules={[
                    {
                      required: true,
                      message: "Please select a Team",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select a Team"
                    mode="multiple"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                  >
                    {AuditUsers.data.map((opt, key) => {
                      return (
                        <Select.Option key={"auditee_" + key} value={opt.id}>
                          {opt.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>

                <Form.Item
                  name="AuditDt"
                  label="Date"
                  placeholder="Select a Date"
                  rules={[{ required: true }]}
                >
                  <DatePicker
                    className="gx-mb-3 gx-w-100"
                    placeholder="Select a Date"
                  />
                </Form.Item>
                <Form.Item className="formBtnGroup" label=" " colon={false}>
                  <Button
                    style={{ textAlign: "center" }}
                    type="primary"
                    htmlType="submit"
                    className="login-form-button gx-mt-1 bigBtn"
                    disabled={state.disabledBtn}
                  >
                    {"Submit"}
                  </Button>
                  {/* <Link to="/audit-list" className="nextBtn">
                                    <Button style={{ textAlign: "center" }} type="danger" htmlType="button" className="login-form-button gx-mt-1 bigBtn"
                                        disabled={
                                            state.disabledBtn
                                        }
                                    >
                                        {"Back to Audit List"}
                                    </Button>
                                </Link> */}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </>
  );
};

export default CreateAndEditAudit;
